import { Space, SpaceVertical } from '@looker/components';
import { BIButton } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { Driver } from 'driver.js';
import type React from 'react';
import { useFilters } from '../../hooks/useFilters';
import { moveToRoot } from './driver';
import { getStepElement } from './stage';
import type { TourStep } from './types';

interface StepBodyProps {
  driver: Driver;
}

export const StepBody: React.FC<StepBodyProps> = ({ driver }) => {
  const { closeFilterDrawer } = useFilters();

  const activeStep = driver.isDrivingThroughChildren
    ? driver.rootSteps[driver.lastRootIndex]
    : (driver.getActiveStep() as TourStep);

  const activeChildStep = driver.isDrivingThroughChildren ? (driver.getActiveStep() as TourStep) : undefined;

  const activeIndex = driver.isDrivingThroughChildren ? driver.lastRootIndex : driver.getActiveIndex();

  const activeChildIndex = driver.isDrivingThroughChildren ? driver.getActiveIndex() : undefined;

  const step = driver.isDrivingThroughChildren ? activeChildStep : activeStep;

  const skipChapter = () => {
    const stepElement = getStepElement(activeStep);
    if (stepElement && activeStep.interaction && stepElement.style.pointerEvents) {
      stepElement.style.pointerEvents = '';
    }

    moveToRoot(driver);
    closeFilterDrawer();
  };

  return (
    <SpaceVertical gap="u3">
      <Space align="start" gap="u1">
        <DsTypography variant="h3">
          {(activeIndex ?? 0) + 1}/{driver.rootSteps?.length ?? 1}:
        </DsTypography>
        {typeof activeStep?.title === 'string' ? (
          <DsTypography variant="h3">{activeStep?.title}</DsTypography>
        ) : (
          activeStep?.title
        )}
      </Space>
      <SpaceVertical gap="u2">
        {driver.isDrivingThroughChildren && (
          <Space gap="u3">
            <Space align="start" gap="u1" width="max-content">
              <DsTypography variant="label">
                {(activeChildIndex ?? 0) + 1}/{driver.getConfig().steps?.length ?? 1}:
              </DsTypography>
              {typeof activeChildStep?.title === 'string' ? (
                <DsTypography variant="label">{activeChildStep?.title}</DsTypography>
              ) : (
                activeChildStep?.title
              )}
            </Space>
            <BIButton color="link" onClick={skipChapter}>
              Skip This Section
            </BIButton>
          </Space>
        )}
        {typeof step?.content === 'string' ? <DsTypography>{step?.content}</DsTypography> : step?.content}
      </SpaceVertical>
    </SpaceVertical>
  );
};
